export const fillStepsParams = [
  'especialidadem',
  'medicom',
  'local',
  'unidadem',
  'planordsl',
  'pacienteDataNascimento',
  'pacienteGenero',
  'healthCardNumber',
  'appointmentId',
  'schedulingId',
  'cartSessionId'
]
